export const AUTH_RESET_PASSWORD_ACCEPT = 'AUTH_RESET_PASSWORD_ACCEPT';
export const AUTH_RESET_PASSWORD_ACCEPT_SUCCESS = 'AUTH_RESET_PASSWORD_ACCEPT_SUCCESS';
export const AUTH_RESET_PASSWORD_ACCEPT_FAILED = 'AUTH_RESET_PASSWORD_ACCEPT_FAILED';
